document.addEventListener("DOMContentLoaded", function () {
    const triggerElement = document.querySelector('.liquid .copyManual');

    // Criação dos botões
    const divPai = document.createElement("div");
    divPai.classList.add("containerAddCartBtnCopy");
    divPai.style.position = 'fixed';
    divPai.style.bottom = '70px';
    divPai.style.left = '50%';
    divPai.style.transform = 'translateX(-50%)';
    divPai.style.maxWidth = '100%';
    divPai.style.zIndex = '1';
    divPai.style.backgroundColor = 'transparent';
    divPai.style.borderRadius = '10px';
    divPai.style.textAlign = 'center';
    divPai.style.boxShadow = '0px 4px 10px rgba(0, 0, 0, 0.1)';
    divPai.style.display = 'none';
    divPai.style.flexDirection = 'column';
    divPai.style.gap = '0.5em';
    divPai.style.alignItems = 'center';

    const buyNowButton = document.createElement("button");
    buyNowButton.id = "BuyNow";
    buyNowButton.classList.add("product-form__add-button", "button", "button--secondary", "button--full", "cartx_mainBtn", "cartx_elem_0");
    buyNowButton.type = "button";
    buyNowButton.style.fontSize = '16px';
    buyNowButton.style.padding = '0';
    buyNowButton.style.minWidth = '80vw';
    buyNowButton.style.backgroundColor = '#9b002b';
    buyNowButton.style.color = '#fff';
    buyNowButton.style.border = '1px solid #9b002b';
    buyNowButton.style.borderRadius = '5px';
    buyNowButton.innerText = "COMPRAR AGORA";

    const addToCartButton = document.createElement("button");
    addToCartButton.id = "StickyAddToCart";
    addToCartButton.classList.add("product-form__add-button", "button", "button--secondary", "button--full", "addCartButtonFixedMob");
    addToCartButton.style.fontSize = '16px';
    addToCartButton.style.padding = '0';
    addToCartButton.style.minWidth = '80vw';
    addToCartButton.style.backgroundColor = '#FFF';
    addToCartButton.style.color = '#001F1A';
    addToCartButton.style.border = '1px solid #001F1A';
    addToCartButton.style.borderRadius = '5px';
    addToCartButton.innerHTML = `
        <span class="loader-button__text">ADICIONAR AO CARRINHO</span>
        <span class="loader-button__loader" hidden="">
            <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
            </div>
        </span>
    `;

    // Evento do botão "Comprar Agora"
    buyNowButton.addEventListener("click", function () {
        const variantId = document.querySelector('[name="id"]')?.value;
        if (!variantId) {
            console.log("Erro ao identificar a variante do produto.");
            return;
        }

        // Adiciona o produto ao carrinho via AJAX
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        })
        .then(response => response.json())
        .then(data => {
            console.log("Produto adicionado ao carrinho!");
            // Marca que o produto foi adicionado no localStorage
            localStorage.setItem('cartUpdated', 'true');
            // Agora, vamos redirecionar para o checkout
            setTimeout(() => {
                window.location.href = "/cart"; // Direciona para o carrinho
            }, 100); // Aguarda um pouco para garantir que o produto foi adicionado
        })
        .catch(error => {
            console.log(`Erro ao adicionar ao carrinho: ${error}`);
        });
    });

    // Evento do botão "Adicionar ao Carrinho"
    addToCartButton.addEventListener("click", function () {
        const variantId = document.querySelector('[name="id"]')?.value;
        if (!variantId) {
            console.log("Erro ao identificar a variante do produto.");
            return;
        }

        // Adiciona o produto ao carrinho via AJAX
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        })
        .then(response => response.json())
        .then(data => {
            console.log("Produto adicionado ao carrinho!");
            // Marca que o produto foi adicionado no localStorage
            localStorage.setItem('cartUpdated', 'true');
            // Dando refresh na página antes de abrir o carrinho
            setTimeout(() => {
                window.location.reload(); // Recarrega a página após o produto ser adicionado
            }, 100); // Aguarda um pouco para garantir que o produto foi adicionado
        })
        .catch(error => {
            console.log(`Erro ao adicionar ao carrinho: ${error}`);
        });
    });

    // Verifica se o carrinho foi atualizado e abre o carrinho após o refresh
    if (localStorage.getItem('cartUpdated') === 'true') {
        localStorage.removeItem('cartUpdated'); // Remove o item do localStorage após abrir o carrinho
        setTimeout(() => {
            const cartDrawer = document.querySelector('#mini-cart');
            if (cartDrawer) {
                cartDrawer.setAttribute('open', ''); // Abre o carrinho
                divPai.style.display = 'none'; // Esconde o botão após abrir o carrinho
            }
        }, 200); // Aguarda um pouco antes de abrir o carrinho
    }

    // Exibe os botões ao adicionar ao carrinho
    divPai.append(addToCartButton, buyNowButton);

    // Função para controlar a visibilidade dos botões ao rolar a tela
    function checkScreenWidth() {
        if (window.innerWidth <= 1050) {
            window.addEventListener('scroll', toggleStickyButton);
            toggleStickyButton();
        } else {
            divPai.style.display = 'none';
        }
    }

    function toggleStickyButton() {
        const triggerRect = triggerElement.getBoundingClientRect();
        if (triggerRect.top <= 550) {
            divPai.style.display = 'flex';
        } else {
            divPai.style.display = 'none';
        }
    }

    // Verifica a largura da tela
    checkScreenWidth();
    window.addEventListener('resize', checkScreenWidth);

    // Garante que os botões sejam adicionados à tela
    if (!document.body.contains(divPai)) {
        document.body.appendChild(divPai);
    }
});
